import { render, staticRenderFns } from "./show_duplicate.html?vue&type=template&id=8e4d24b8&scoped=true&"
import script from "./show_duplicate.js?vue&type=script&lang=js&"
export * from "./show_duplicate.js?vue&type=script&lang=js&"
import style0 from "./show_duplicate.scss?vue&type=style&index=0&id=8e4d24b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4d24b8",
  null
  
)

export default component.exports